module.exports = __webpack_public_path__ + "img/innovations_medium.de280034.jpg";